import { ReportsAndLogs, SequenceReports, ParseTemplateContainer, QuotesAndOrders, InvoicesReport, TextHistory } from 'pages';
import CallHistoryLog from 'pages/CallHistoryLog';
import { PRODUCT_PERMISSIONS, USER_PERMISSIONS } from 'dyl-components';
import PipelineReports from 'pages/PipelineReports';
import { QueryParamsUtils } from 'utils';
import TextingComponentProvider from 'shared/context/TextingComponentProvider';
import ArchivedReports from 'pages/ArchivedReports';

const PARENT_NAME = "reports_and_logs";

export const REPORTS_AND_LOGS_SETTINGS = [
    {
        path: `data-integration-logs`,
        icon: 'fas fa-table',
        header: 'Data Integration Log',
        description: 'View incoming posts and emails, and parse your data for mapping.',
        page: ReportsAndLogs,
        type: `${PARENT_NAME}.data_integration_log`,favorite_type: "reports",
        userPermission: USER_PERMISSIONS.DATA_INTEGRATION_LOG_REPORT_VIEW
    },
    {
        path: `sequence-reports`,
        setTimestampParameters: QueryParamsUtils.getDayTimestampsParameter,
        icon: 'fa-solid fa-network-wired',
        header: 'Sequence Report',
        description: 'View all sequence task activities.',
        page: SequenceReports,
        type: `${PARENT_NAME}.sequence_report`,
        favorite_type: "reports",
        userPermission: USER_PERMISSIONS.SEQUENCE_REPORT_VIEW
    },
    {
        path: `email-parsing-template/:email_id`,
        icon: 'fas fa-table',
        header: 'Parse Email',
        description: 'Parse Emails',
        page: ParseTemplateContainer,
        exclude: true,
        parent: {
            path: 'data-integration-logs',
            name: 'Data Integration Log'
        },
        userPermission: USER_PERMISSIONS.DATA_INTEGRATION_LOG_REPORT_VIEW
    },
    {
        path: `post-parsing-template/:post_id`,
        icon: 'fas fa-table',
        header: 'Parse Post',
        description: 'Parse Post',
        page: ParseTemplateContainer,
        exclude: true,
        parent: {
            path: 'data-integration-logs',
            name: 'Data Integration Log'
        },
        userPermission: USER_PERMISSIONS.DATA_INTEGRATION_LOG_REPORT_VIEW
    },
    {
        path: `quotes-orders`,
        setTimestampParameters: QueryParamsUtils.getDayTimestampsParameter,
        icon: 'fa-solid fa-box-dollar',
        header: 'Quotes & Orders',
        description: 'View all quotes and orders',
        page: QuotesAndOrders,
        type: `${PARENT_NAME}.quotes_orders`,
        favorite_type: "reports",
        userPermission: USER_PERMISSIONS.QUOTES_AND_ORDERS_REPORT_VIEW
    },
    {
        path: `invoices`,
        setTimestampParameters: QueryParamsUtils.getDayTimestampsParameter,
        icon: 'fa-solid fa-file-invoice-dollar',
        header: 'Invoices',
        description: 'View all invoices',
        page: InvoicesReport,
        type: `${PARENT_NAME}.invoices`,
        favorite_type: "reports",
        userPermission: USER_PERMISSIONS.INVOICE_REPORT_VIEW
    }, 
    {
        path: "call-history",
        setTimestampParameters: (userAuthTimezone) => {
            return QueryParamsUtils.getDayTimestampsParameter(userAuthTimezone, 'start_at', 'end_at');
        },
        icon: "fa-solid fa-phone",
        header: "Call History Log",
        description:
            "View all call information including voicemails and recordings.",
        page: CallHistoryLog,
        type: `${PARENT_NAME}.call_history`,
        favorite_type: "reports",
        userPermission: USER_PERMISSIONS.CALL_HISTORY_REPORT_VIEW
    },
    {
        path: "text-history",
        icon: "fa-solid fa-comments",
        header: "Text History",
        description:
            "View all texts.",
        page: () => <TextingComponentProvider><TextHistory /></TextingComponentProvider>,
        type: `${PARENT_NAME}.text_history`,
        favorite_type: "reports",
        userPermission: USER_PERMISSIONS.TEXTING_HISTORY_REPORT_VIEW,
        productPermission: PRODUCT_PERMISSIONS.TEXT_VIEW
    },
    {
        path: "pipeline-reports",
        icon: "fa-solid fa-filter-list",
        header: "Pipeline Reports",
        description:
            "View all active Leads and Opportunities within pipeline stages.",
        page: PipelineReports,
        type: `${PARENT_NAME}.pipeline_reports`,
        favorite_type: "reports",
        userPermission: USER_PERMISSIONS.PIPELINES_REPORT_VIEW
    },
    {
        path: "archived-records",
        icon: "fa-solid fa-archive",
        header: "Archived Records",
        description:
            "View all archived Contacts and Accounts.",
        page: ArchivedReports,
        type: `${PARENT_NAME}.archived_records`,
        favorite_type: "reports",
        userPermission: USER_PERMISSIONS.ARCHIVE_VIEW
    },

];
